export const employeeName = (e) =>
    (e?.full_name || `${e?.last_name || ""} ${e?.first_name || ""}`).trim() || e?.email || "—";

// Phone digits without the 0 / +234 prefix, so "0803…" and "+234 803…" match each other.
const phoneCore = (v) => {
    const d = String(v || "").replace(/\D/g, "");
    return d.startsWith("234") ? d.slice(3) : d.replace(/^0+/, "");
};

// Matches name, staff no, department, division and phone (every word must match somewhere).
export const employeeMatches = (e, query) => {
    const raw = (query || "").trim().toLowerCase();
    if (!raw) return true;
    const pc = phoneCore(e.phone);
    const qc = phoneCore(raw);
    if (/^[+\d\s\-()]+$/.test(raw) && qc.length >= 4 && pc.includes(qc)) return true;
    const hay = [
        e.full_name, e.first_name, e.last_name, e.other_name, e.employee_no,
        e.department, e.division, e.email, e.position, e.phone, pc,
    ].filter(Boolean).join(" ").toLowerCase();
    return raw.split(/\s+/).every((w) => hay.includes(w));
};
